import { render, staticRenderFns } from "./ChoosePassword.vue?vue&type=template&id=8a586640&"
import script from "./ChoosePassword.vue?vue&type=script&lang=js&"
export * from "./ChoosePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports